import { Link } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";

export default function NotFoundPage() {
  const { user } = useAuth();
  const home = user ? "/" : "/login";
  return (
    <div className="min-h-dvh bg-[var(--cream)] flex flex-col items-center justify-center px-6 text-center">
      <p className="eyebrow text-[var(--coffee-muted)]">404 · página perdida</p>
      <h1 className="serif text-6xl text-[var(--coffee)] mt-3 leading-[0.95]">
        Aqui não<br /><em className="font-light">tem página.</em>
      </h1>
      <p className="hand text-2xl text-[var(--coral)] mt-6">respira e volta pra base.</p>
      <Link to={home} className="btn-primary mt-10 px-8 h-14 text-base flex items-center justify-center" data-testid="notfound-home-link">
        {user ? "voltar pra Nossa Base" : "ir para o login"}
      </Link>
    </div>
  );
}
